'use strict';

import { EwSiteApp } from "./ewsiteapp";

EwSiteApp.controller('TabsCtrl', ['$scope', function($scope) {
    $scope.scrollTabs = function(direction) {
        const container = document.querySelector('.tabs-container');
        if (!container) return;
        const scrollAmount = 150;
        container.scrollBy({
            left: direction === 'left' ? -scrollAmount : scrollAmount,
            behavior: 'smooth'
        });
    };
}]);
